import { Button, Column, FormControl, Row, Subheading, Textarea } from "@gadgetinc/widgets";
import React, { useContext, useState } from "react";
import { useStyletron } from "baseui";
import { trackEvent } from "web/src/lib/eventTracker";
import { Paragraph } from "../markdown-components";
import { useDocsLocation } from "../chrome/nav/useDocsLocation";
import { DocsContext } from "../chrome/DocsContext";
import { currentDocsVersion } from "../chrome/nav/DocsVersionSelector";

enum DocsFeedbackType {
  None = "",
  Positive = "positive",
  Negative = "negative",
}

export const DocsFeedback = () => {
  const [feedbackType, setFeedbackType] = useState(DocsFeedbackType.None);
  const [feedback, setFeedback] = useState("");
  const [submitted, setSubmitted] = useState(false);

  const [location] = useDocsLocation();
  const { currentApp, currentUser } = useContext(DocsContext);

  const [_css, $theme] = useStyletron();

  // handle feedback submission
  const handleSubmit = () => {
    setSubmitted(true);

    // build feedback object to be logged
    const version = currentDocsVersion(location, currentApp);
    const docsFeedback = {
      feedbackType: feedbackType,
      feedback,
      page: location,
      version: {
        id: version.id,
        dir: version.dir,
        frameworkRange: version.frameworkRange,
      },
      userId: currentUser?.id,
      application_id: currentApp?.id,
      environment_id: currentApp?.environmentID,
    };

    trackEvent("docs_feedback", docsFeedback, "docs");
  };

  return (
    <div>
      {!submitted ? (
        feedbackType === DocsFeedbackType.None ? (
          <Column $align="start">
            <Subheading $style={{ ...$theme.typography.LabelMedium, fontWeight: 400 }}>Was this page helpful?</Subheading>
            <Row
              $style={{
                gap: $theme.sizing.scale300,
                paddingTop: $theme.sizing.scale300,
                paddingBottom: $theme.sizing.scale300,
              }}
            >
              <Button kind="secondary" onClick={() => setFeedbackType(DocsFeedbackType.Positive)}>
                Yes &#x1F44D;
              </Button>
              <Button kind="secondary" onClick={() => setFeedbackType(DocsFeedbackType.Negative)}>
                No &#x1F44E;
              </Button>
            </Row>
          </Column>
        ) : (
          <Column
            $align="center"
            $style={{
              gap: $theme.sizing.scale300,
            }}
          >
            <FormControl label={feedbackType == DocsFeedbackType.Positive ? "What went well?" : "What went wrong?"}>
              <Textarea
                value={feedback}
                onChange={(e) => setFeedback(e.currentTarget.value)}
                placeholder="(Optional) Please provide more details..."
                size="compact"
              />
            </FormControl>
            <Button kind="secondary" onClick={handleSubmit}>
              Submit
            </Button>
          </Column>
        )
      ) : (
        <Paragraph>Thank you for your feedback!</Paragraph>
      )}
    </div>
  );
};
